import React from "react";
import useScopedOrgType from "@/hooks/useScopedOrgType";
import OrganizationType from "@/cleanup/utils/OrganizationType";
import PageHeader from "@/cleanup/containers/PageHeader/PageHeader";
import { LanguageKey } from "@/types/generated/LanguageKey";
import { translate } from "@/hooks/useLanguage";
import NotAvailableAtThisLevel, { NotAvailableReasonConst } from "./NotAvailableAtThisLevel";

interface NotOnStockProps {
  /** The page's header, the label of the menu entry that opens it. */
  title: LanguageKey;
  children: React.ReactNode;
}

/**
 * STIC-11419: renders the page unless the organisation in scope is a stock
 * organisation, which only holds devices and asset tags. Wraps the routes of the
 * menu entries greyed for a stock organisation, so their page never mounts (and
 * never calls the backend, which refuses the stock organisation) there.
 */
const NotOnStock: React.FC<NotOnStockProps> = ({ title, children }) => {
  const scopedOrgType = useScopedOrgType();
  if (scopedOrgType === null) {
    return null;
  }
  if (scopedOrgType === OrganizationType.STOCK) {
    return (
      <>
        <PageHeader title={translate(title)} tabTitle={translate(title)} />
        <NotAvailableAtThisLevel reason={NotAvailableReasonConst.NOT_ON_STOCK} />
      </>
    );
  }
  return <>{children}</>;
};

export default NotOnStock;
